import type { BetaFeatureKey } from '@/constants/betaFeatures';

export enum ProfileSection {
  ADMIN = 'admin',
  ASK_AI = 'ask-ai',
  BASIC_INFO = 'basic-info',
  CARE_TEAM = 'care-team',
  CHALLENGE_RESPONSE = 'last-challenge-response',
  CHECKLIST = 'checklist',
  CLASSIFICATIONS = 'classifications',
  CONTACT_INFO = 'contact-info',
  DEMOGRAPHICS = 'demographics',
  DISCHARGE_AND_REJECTIONS = 'discharge-rejections',
  ENGAGEMENT_INFORMATION = 'engagement-information',
  EPISODE_OF_CARE = 'episode-of-care',
  INSURANCE = 'insurance',
  MEDICATIONS = 'medications',
  MEMBER_AVAILABILITY = 'member-availability',
  OUTLINKS = 'outlinks',
  PERSON_DUPLICATES = 'person-duplicates',
  PROGRAM_QUALIFICATION = 'program-qualification',
  RECOVERY_GOAL = 'recovery-goal',
  RECENT_CONTACT = 'recent-contact',
  REFERRALS = 'referrals',
  SCHEDULE = 'next-appointments',
  SCHEDULING_LINKS = 'scheduling-links',
  SEGMENTS = 'segments',
  TAGS = 'tags',
  TASKS = 'tasks',
  TREATABILITY = 'treatability'
}

export interface DraggableSection {
  /** A beta this section can switch to; its header then carries the switch. */
  betaFeature?: BetaFeatureKey;
  defaultOpen: boolean;
  /** The reader (or their role default) tucked the card away at the bottom of the page. */
  hidden?: boolean;
  /** A `ProfileSection` on the profile, and the encounter view's own sections there. */
  id: string;
  /** Set when the member has nothing for the card to show, so it is left off the page. Not
   * to be confused with a card the reader chose to hide, which is kept in their card order. */
  isUnavailable?: boolean;
  title: string;
}

export {};
